import { Image } from 'antd';
import { t } from 'i18next';
import * as StyledShared from '../../styles';
import PurchasePending from 'assets/images/payment/pending.gif';

export const NftPurchasePending = () => {
  return (
    <>
      <Image
        src={PurchasePending}
        preview={false}
        height={180}
        width={180}
        alt={t('payment.waitingForTheResponse')}
      />
      <StyledShared.MessageTitle>
        {t('payment.waitingForTheResponse')}
      </StyledShared.MessageTitle>
      <StyledShared.MessageSubtitle>
        {t('payment.pleaseWait')}
      </StyledShared.MessageSubtitle>
    </>
  );
};
